var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 751,
    height: 46,
    viewBox: "0 0 751 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-darker"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4671 22.5985C49.3033 21.9716 136.121 21.1366 188.466 21.004C240.812 20.8713 286.015 24.3951 330.59 24.755C375.166 25.1148 429.726 22.408 472.08 23.2349C514.434 24.0618 682.743 20.2835 728.725 22.2575",
    stroke: "#67FC17",
    strokeOpacity: 0.7,
    strokeWidth: 42,
    strokeLinecap: "square"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineBottom);
export default __webpack_public_path__ + "static/media/line-bottom.5a0824510c3aa14a8d900bd2d421d114.svg";
export { ForwardRef as ReactComponent };